<template>
    <NuxtLayout name="bio-tools">
        <div class="manual">
            <slot></slot>
        </div>
    </NuxtLayout>
</template>

<style lang="less" scoped>
.manual {
    margin: 92px auto 0;

    :deep(.manual-container) {
        h1 {
            line-height: 56px;
            font-weight: bold;
            font-size: 48px;
            color: var(--uicolor-font-1);
        }

        h2 {
            border-bottom: 1px solid var(--uicolor-font-4-05);
            line-height: 44px;
            font-weight: bold;
            font-size: 36px;
            padding: 0 0 44px;
            margin: 0 0 44px;
            color: var(--uicolor-font-1);
        }

        h3 {
            line-height: 32px;
            font-weight: bold;
            font-size: 24px;
            margin: 56px 0 32px;
            color: var(--uicolor-font-1);
        }

        h4 {
            line-height: 24px;
            font-weight: bold;
            font-size: 16px;
            color: var(--uicolor-font-1);
        }

        section {
            margin: 88px 0 0;
        }

        .descript {
            color: #666;
            margin: -4px 0;
            line-height: 30px;
        }

        .summarys {
            margin: 40px 0 0;

            .descript {
                margin: -4px 0 20px;
            }

            .summary-img {
                margin: 4px 0 36px;
            }

            .summary-item {
                margin: 0 0 24px;
                display: flex;
                padding: 0 0 0 12px;
                position: relative;
                align-items: center;

                &::before {
                    top: 13px;
                    left: 0;
                    width: 4px;
                    height: 4px;
                    content: "";
                    position: absolute;
                    background: #6d747f;
                    border-radius: 50%;
                }

                &:last-child {
                    margin: 0;
                }
            }

            .summary-items {
                margin-bottom: 32px;
            }

            .summarys-title {
                margin: 0 0 24px;
                cursor: pointer;
                display: flex;
                transition: all 0.3s;
                align-items: center;

                .summarys-icon {
                    margin: 0 8px 0 0;
                    width: 12px;
                    height: 12px;
                    border: 1px solid #6d747f;
                    position: relative;
                    transition: all 0.3s;
                    border-radius: 2px;

                    &::before,
                    &::after {
                        top: 50%;
                        left: 50%;
                        content: "";
                        position: absolute;
                        transition: all 0.3s;
                        background: #6d747f;
                    }

                    &::before {
                        width: 6px;
                        height: 2px;
                        margin: -1px 0 0 -3px;
                    }

                    &::after {
                        width: 2px;
                        height: 6px;
                        margin: -3px 0 0 -1px;
                        display: none;
                    }
                }
            }

            .summarys-title.active {
                .summarys-icon {
                    &::after {
                        width: 2px;
                        height: 6px;
                        margin: -3px 0 0 -1px;
                        display: block;
                    }
                }
            }

            *:last-child {
                margin-bottom: 0;
            }
        }
    }
}
</style>
